"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ThresholdConfigurator_1 = require("../../ThresholdConfigurator");
const ThresholdButton_1 = require("../../ThresholdConfigurator/ThresholdButtons/ThresholdButton");
const S = __importStar(require("./Legend.style"));
const Legend = ({ onClose }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(S.LegendContainer, null,
        react_1.default.createElement(S.Header, null,
            react_1.default.createElement(S.CloseButton, { onClick: onClose }),
            react_1.default.createElement(S.Title, null, t("map.legend.title"))),
        react_1.default.createElement(S.SliderContainer, null,
            react_1.default.createElement(ThresholdConfigurator_1.ThresholdsConfigurator, { resetButtonVariant: ThresholdButton_1.ThresholdButtonVariant.TextWithIcon, resetButtonText: t("map.legend.resetRangesButton"), useColorBoxStyle: true, useDarkBlueIcon: true })),
        react_1.default.createElement(S.ApplyButton, { onClick: onClose }, t("map.legend.applyButton"))));
};
exports.Legend = Legend;
